//工具类
// 根据路由获取页面id
function Fndata(dataList, path, newarr = []) {
  if (dataList && dataList.length) {
    dataList.forEach((item) => {
      if (
        item.ename &&
        path ===
          item.ename.substring(
            item.ename.lastIndexOf("/") + 1,
            item.ename.length
          )
      ) {
        let obj = {
          name: item.cname,
          id: item.id,
        };
        newarr.push(obj);
      }

      if (item.children && item.children.length) {
        Fndata(item.children, path, newarr);
      }
    });
  }
  return newarr;
}

export default { Fndata };
